export default {
  headerTile: 'Alles wat je moet weten over jouw reis',
  contact: 'Contact',
  noContacts: 'Er zijn geen contacten',
  tourResume: 'Overzicht',
  stageInformation: "Informatie over de etappe",
  extraField: 'Extra\'s',
  day: 'Dag',
  tour: 'Jouw reis',
  flight: 'Vlucht',
  transfer: 'Transfer',
  transportLuggage: 'Transport van je bagage',
  stageNumOriginDestination: 'Etappe: {origin} - {destination}',
  distanceNumberKm: 'Afstand: {number} Km',
  notSelectTransfer: 'U heeft nog geen transfer geselecteerd',
  notSelectTransport: 'U heeft nog geen transport geselecteerd',
  accommodation: 'Accommodatie',
  information: 'Informatie',
  quantityNights: 'Geen nachten | Eén nacht | {n} nachten',
  totalPrice: 'Totaalprijs',
  whatToDoLocation: 'Wat te doen in {location}',
  urlToLocationMap: 'URL naar kaart van {location}',
  urlToLocationWeb: 'URL naar website van {location}',
  website: 'Website',
  map: 'Kaart',
  linkAboutDay: 'Link over de dag',
  guidebookLocation: 'Tips: {location}',
  viewWebsite: 'Meer informatie',
  viewGoogleMaps: 'Bekijken in Google Maps',
  dayInformation: 'Beschrijving',
  guidebookOfLocation: 'Tips van {location}',
  linkGoogleMapsResource: 'Link naar Google Maps van {resource}',
  linkResourceWebsite: 'Link naar {resource} website',
  address: 'Adres',
  noResourcesLocation: 'Er zijn nog geen bronnen toegevoegd aan deze locatie',
  viewWebsiteOfSupplier: 'Bekijk de website van {supplier}',
  urlGoogleMapsOfSupplier: 'URL naar Google Maps van {supplier}',
  travelInformation: 'Uw reisinformatie',
  pricePerPerson: 'Prijs per persoon',
  downloadErrorText: 'Er is een fout opgetreden tijdens het downloaden',
  pricePerUnit: '€/eenheid',
  printTravelBook: 'PDF downloaden',
  downloadPdf: 'PDF downloaden',
  preferNotPrintTitle: '🌿 Liever niet printen!',
  preferNotPrintIntro: 'Denk een beetje aan het milieu en gebruik je reisdocument lekker digitaal op je telefoon of tablet. 📱🥾',
  preferNotPrintOfficial: 'De online versie is jouw officiële reisdocument en is altijd actueel. Eventuele wijzigingen worden meteen aangepast, zodat je altijd de nieuwste informatie bij de hand hebt. ✔️',
  preferNotPrintFooter: 'Scheelt papier én je hebt alles bij de hand 🌍💚',
  stayDigital: 'Digitaal houden',
  downloadPdfAnyway: 'Toch downloaden',
  preparedFor: 'Voorbereid voor',
  reference: 'Referentie',
  beforeTrip: 'Voor je vertrek',
  luggage: 'Transport van je bagage',
  emergenciesInSpain: 'Noodgevallen in Spanje',
  afterTrip: 'Na je thuiskomst',
  supportContacts: 'Ondersteuning & Contacten',
  needToKnow: 'Goed om te weten',
  inclusionsExclusions: 'Inbegrepen en niet inbegrepen',
  whatsIncluded: 'Inbegrepen',
  whatsNotIncluded: 'Niet inbegrepen',
  optionalExtras: 'Optionele extra\'s',
  readyToAdventure: 'Klaar voor avontuur?',
  finalizeReservation: 'Rond uw reservering af en vergrendel vandaag nog uw gepersonaliseerde reisroute.',
  whatsappSpecialist: 'WhatsApp Specialist',
  requestReservation: 'Reservering aanvragen',
  itineraryNotFound: 'Routebeschrijving niet gevonden',
  itineraryNotFoundDescription: 'We konden deze reisroute niet ophalen. Deze kan zijn verlopen of de link is ongeldig.',
  returnHome: 'Terug naar home',
  featuredImage: 'Uitgelichte reisafbeelding',
  displayMode: 'Weergavemodus',
  colorMode: 'Kleur',
  darkMode: 'Donker',
  km: 'km',
  service: 'Dienst',
  services: 'Diensten',
  viewMore: 'Meer bekijken',
  viewLess: 'Minder bekijken',
  stayContinues: 'Verblijf loopt door',
  hotel: 'Accommodatie',
  refuge: 'Berghut',
  hotelOptions: 'Accommodatieopties',
  selectHotel: 'Kies een hotel',
  activityPreviewNote: 'Activiteitvoorbeeld. Dit is het reisboek dat de klant krijgt, zonder klantgegevens of kamerkeuze.',
  noServicesThisDay: 'Geen diensten op deze dag',
  restaurant: 'Restaurant',
  activity: 'Activiteit',
  transport: 'Transport',
  general_information: 'Algemene Informatie',
  stage_information: 'Etappe Informatie',
  files: 'Bestanden',
  openFile: 'Bestand openen',
  downloadFile: 'Downloaden',
};
